import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { SDKStudy } from '@axon/rosetta-sdk';
import { LibraryEndpoint } from 'libs.react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
import { useCurrentEnvironment } from '../use_current_environment';
export const useStudyEConsentEnabled = () => {
    const { environment } = useCurrentEnvironment();
    const studyId = environment?.studyId;
    const libraryClient = useApiClient(ApiClientService.LIBRARY);
    const { data: studyConfig, isLoading } = useQuery({
        queryKey: ['study_econsent_enabled', studyId],
        queryFn: async () => {
            const searchParams = new URLSearchParams({ studyId: String(studyId) });
            const { data: response } = await libraryClient.get(`${LibraryEndpoint.GET_STUDY_CONFIGS}?${searchParams.toString()}`);
            return response.data?.[0] ?? null;
        },
        enabled: !!studyId,
    });
    const isEConsentEnabled = useMemo(() => {
        if (!studyConfig?.data) {
            return false;
        }
        try {
            return SDKStudy.fromRosetta(studyConfig.data).studyMetadata?.isEConsentEnabled ?? false;
        }
        catch {
            return false;
        }
    }, [studyConfig]);
    return { isEConsentEnabled, isLoading: !!studyId && isLoading };
};
